<template>
  <div
    class="rfp-rr-show-full-review-157-or full-review-popup mobile-view-alignment"
    style="display: block"
  >
    <div class="rfp-rr-show-full-review-158-or review-popup-close" @click="closePopup">X</div>
    <h3 v-if="showHideSubTitles" class="rfp-rr-show-full-review-159-or rr-sub-title black clear">
      {{ headerTitle }}
    </h3>
    <div
      v-if="showHodeQualityOfProducts"
      class="rfp-rr-show-full-review-160-or rr-avg-rating-content float-right"
    >
      <span class="rfp-rr-show-full-review-161-or rr-label float-left bold">{{
        labelQualityOfProduct
      }}</span>
      <span class="rfp-rr-show-full-review-162-or rr-rating-bar-outer float-left"
        ><span
          class="rfp-rr-show-full-review-163-or rr-rating-bar-inner"
          :style="{ width: rateQualityOfProduct * 20 + '%' }"
        ></span
      ></span>
      <span class="rfp-rr-show-full-review-164-or rr-label-info float-left bold">{{
        rateQualityOfProduct
      }}</span>
    </div>
    <p class="rfp-rr-show-full-review-165-or clear">{{ summary }}</p>
    <div class="rfp-rr-show-full-review-166-or rr-recomment-product clear">
      <div class="rfp-rr-show-full-review-167-or rr-sample-section float-left">
        <p style="margin-right: 0px">
          <img
            :src="recommendListIcons"
            class="rfp-rr-show-full-review-168-or image-setup-for-list"
            :alt="recommendIconAltTexts"
          />
        </p>
        <p>
          {{ isRecommends }}
        </p>
      </div>
    </div>
    <div class="rfp-rr-show-full-review-169-or rr-comment-img-section clear float-left">
      <div class="rfp-rr-show-full-review-170-or review-gallery"></div>
    </div>
    <rfp-ratings-helpful
      :reported-text="reportedTexts"
      :report-text="reportTexts"
      :report="reports"
      :helpful-label="helpfulLabels"
      :rrid="rrids"
      :report-display="0"
      :is-helpful-cookie="isHelpfulCookies"
      :helpful-count="helpfulCounts"
      :not-helpful-count="notHelpfulCounts"
      :update-helpful-review-api="updateHelpfulReviewApis"
      :update-not-helpful-review-api="updateNotHelpfulReviewApis"
      :report-review-api="reportReviewApis"
      :helpful-iconss="helpfulIcons"
      :helpful-icon-altss="helpfulIconAlts"
      :non-helpful-iconss="nonHelpfulIcons"
      :non-helpful-icon-altss="nonHelpfulIconAlts"
      :product-namess="productNames"
      :review-contentss="reviewContents"
      :review-titless="reviewTitles"
      :facebook-captionss="facebookCaptions"
      :facebook-share-enabledss="facebookShareEnableds"
      :share-display-configss="shareDisplayConfigs"
      :facebook-iconss="facebookIcons"
      :facebook-icon-altss="facebookIconAlts"
      :facebook-tool-tipss="facebookToolTips"
    ></rfp-ratings-helpful>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@loreal/eventbus-js';
import RfpRatingsHelpful from '@/components/widget/rfp-ratings-helpful/rfp-ratings-helpful.vue';

export default {
  name: 'rfp-ratings-show-full-review',
  components: {
    RfpRatingsHelpful,
  },
  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    labelQualityOfProduct: {
      type: String,
      required: false,
    },
    rateQualityOfProduct: {
      type: String,
      required: false,
    },
    summary: {
      type: String,
      required: false,
    },
    rrids: {
      type: Number,
      required: false,
    },
    helpfulLabels: {
      type: String,
      required: false,
    },
    reports: {
      type: String,
      required: false,
    },
    reportedTexts: {
      type: String,
      required: false,
    },
    reportTexts: {
      type: String,
      required: true,
    },
    isHelpfulCookies: {
      type: String,
      required: false,
    },
    helpfulCounts: {
      type: Number,
      required: false,
    },
    notHelpfulCounts: {
      type: Number,
      required: false,
    },
    updateHelpfulReviewApis: {
      type: String,
      required: false,
    },
    updateNotHelpfulReviewApis: {
      type: String,
      required: false,
    },
    reportReviewApis: {
      type: String,
      required: false,
    },
    isRecommends: {
      type: String,
      required: false,
    },
    helpfulIcons: {
      type: String,
      required: true,
    },
    helpfulIconAlts: {
      type: String,
      required: true,
    },
    nonHelpfulIcons: {
      type: String,
      required: true,
    },
    nonHelpfulIconAlts: {
      type: String,
      required: true,
    },
    recommendListIcons: {
      type: String,
      required: true,
    },
    recommendIconAltTexts: {
      type: String,
      required: true,
    },
    productNames: {
      type: String,
      required: true,
    },
    reviewContents: {
      type: String,
      required: true,
    },
    reviewTitles: {
      type: String,
      required: true,
    },
    facebookCaptions: {
      type: String,
      default: 'Facebook',
    },
    facebookShareEnableds: {
      type: Boolean,
      required: true,
    },
    shareDisplayConfigs: {
      type: String,
      required: true,
    },
    facebookIcons: {
      type: String,
      default: '',
    },
    facebookIconAlts: {
      type: String,
      default: '',
    },
    showHodeQualityOfProducts: {
      type: String,
      required: true,
    },
    showHideSubTitles: {
      type: String,
      required: true,
    },
  },
  methods: {
    closePopup() {
      eventBus.emit('helpfulPopupStatus');
    },
  },
};
</script>
